var _circle, _circle2, _circle3, _circle4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 57.75,
    fill: "url(#paint0_linear_2098_16259)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 54.25,
    fill: "url(#paint1_linear_2098_16259)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 49.875,
    fill: "url(#paint2_radial_2098_16259)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2098_16259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 100,
    height: 100
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 49.875,
    fill: "url(#paint3_radial_2098_16259)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2098_16259)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 86,
    width: 97.125,
    height: 34.125,
    fill: "#2C0E87"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.625 57.125C53.625 62.4406 49.3159 66.75 44 66.75C38.6841 66.75 34.375 62.4406 34.375 57.125C34.375 51.8094 38.6841 47.5 44 47.5C49.3159 47.5 53.625 51.8094 53.625 57.125Z",
    fill: "#5027CD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.625 57.125C53.625 62.4406 49.3159 66.75 44 66.75C38.6841 66.75 34.375 62.4406 34.375 57.125C34.375 51.8094 38.6841 47.5 44 47.5C49.3159 47.5 53.625 51.8094 53.625 57.125Z",
    stroke: "url(#paint4_linear_2098_16259)",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.625 57.125C81.625 62.4406 77.3159 66.75 72 66.75C66.6841 66.75 62.375 62.4406 62.375 57.125C62.375 51.8094 66.6841 47.5 72 47.5C77.3159 47.5 81.625 51.8094 81.625 57.125Z",
    fill: "#FF8AC2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.625 57.125C81.625 62.4406 77.3159 66.75 72 66.75C66.6841 66.75 62.375 62.4406 62.375 57.125C62.375 51.8094 66.6841 47.5 72 47.5C77.3159 47.5 81.625 51.8094 81.625 57.125Z",
    stroke: "url(#paint5_linear_2098_16259)",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.25 86H24.75C27.1718 76.9004 34.375 70.25 43.9993 70.25C53.6236 70.25 60.8282 76.9004 63.25 86Z",
    fill: "#FF8AC2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.25 86H24.75C27.1718 76.9004 34.375 70.25 43.9993 70.25C53.6236 70.25 60.8282 76.9004 63.25 86Z",
    stroke: "url(#paint6_linear_2098_16259)",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.25 86H52.75C55.1718 76.9004 62.375 70.25 71.9993 70.25C81.6236 70.25 88.8282 76.9004 91.25 86Z",
    fill: "#5027CD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.25 86H52.75C55.1718 76.9004 62.375 70.25 71.9993 70.25C81.6236 70.25 88.8282 76.9004 91.25 86Z",
    stroke: "url(#paint7_linear_2098_16259)",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7908 62.9812L21.8664 63.7371L21.1171 66.6881C20.9792 67.2309 20.2148 67.2309 20.0774 66.6881L19.3281 63.7371L16.4037 62.9812C15.8654 62.842 15.8654 62.071 16.4037 61.9318L19.3281 61.1759L20.0774 58.2249C20.2148 57.6816 20.9792 57.6816 21.1171 58.2249L21.8664 61.1759L24.7908 61.9318C25.3291 62.071 25.3291 62.842 24.7908 62.9812Z",
    fill: "url(#paint8_linear_2098_16259)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9158 28.1638L76.9914 28.9197L76.2421 31.8707C76.1042 32.4135 75.3398 32.4135 75.2024 31.8707L74.4531 28.9197L71.5287 28.1638C70.9904 28.0246 70.9904 27.2536 71.5287 27.114L74.4531 26.3585L75.2024 23.4075C75.3398 22.8642 76.1042 22.8642 76.2421 23.4075L76.9914 26.3585L79.9158 27.114C80.4541 27.2536 80.4541 28.0246 79.9158 28.1638Z",
    fill: "url(#paint9_linear_2098_16259)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9158 28.1638L41.9914 28.9197L41.2421 31.8707C41.1042 32.4135 40.3398 32.4135 40.2024 31.8707L39.4531 28.9197L36.5287 28.1638C35.9904 28.0246 35.9904 27.2536 36.5287 27.114L39.4531 26.3585L40.2024 23.4075C40.3398 22.8642 41.1042 22.8642 41.2421 23.4075L41.9914 26.3585L44.9158 27.114C45.4541 27.2536 45.4541 28.0246 44.9158 28.1638Z",
    fill: "url(#paint10_linear_2098_16259)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_di_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5966 53.1184L96.6722 53.8743L95.9229 56.8253C95.785 57.3681 95.0206 57.3681 94.8827 56.8253L94.1339 53.8743L91.209 53.1184C90.6712 52.9792 90.6712 52.2077 91.209 52.0686L94.1339 51.3131L94.8827 48.3621C95.0206 47.8188 95.785 47.8188 95.9229 48.3621L96.6722 51.3131L99.5966 52.0686C100.135 52.2077 100.135 52.9792 99.5966 53.1184Z",
    fill: "url(#paint11_linear_2098_16259)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_di_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2909 37.7888L60.3665 38.5447L59.6172 41.4957C59.4793 42.0385 58.7149 42.0385 58.577 41.4957L57.8282 38.5447L54.9034 37.7888C54.3655 37.6496 54.3655 36.8781 54.9034 36.739L57.8282 35.9831L58.577 33.0325C58.7149 32.4892 59.4793 32.4892 59.6172 33.0325L60.3665 35.9831L63.2909 36.739C63.8292 36.8781 63.8292 37.6496 63.2909 37.7888Z",
    fill: "url(#paint12_linear_2098_16259)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_di_2098_16259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2909 96.4138L60.3665 97.1697L59.6172 100.121C59.4793 100.664 58.7149 100.664 58.577 100.121L57.8282 97.1697L54.9034 96.4138C54.3655 96.2746 54.3655 95.5031 54.9034 95.364L57.8282 94.6081L58.577 91.6575C58.7149 91.1142 59.4793 91.1142 59.6172 91.6575L60.3665 94.6081L63.2909 95.364C63.8292 95.5031 63.8292 96.2746 63.2909 96.4138Z",
    fill: "url(#paint13_linear_2098_16259)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 86L103.5 86",
    stroke: "url(#paint14_linear_2098_16259)",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2098_16259",
    x: 33.5,
    y: 46.625,
    width: 22.75,
    height: 22.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.75,
    dy: 1.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2098_16259",
    x: 61.5,
    y: 46.625,
    width: 22.75,
    height: 22.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.75,
    dy: 1.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2098_16259",
    x: 23.875,
    y: 69.375,
    width: 42,
    height: 19.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.75,
    dy: 1.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2098_16259",
    x: 51.875,
    y: 69.375,
    width: 42,
    height: 19.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.75,
    dy: 1.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_2098_16259",
    x: 12.5,
    y: 54.3174,
    width: 16.1945,
    height: 16.2778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2098_16259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2098_16259",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.152941 0 0 0 0 0.803922 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_2098_16259",
    x: 67.625,
    y: 19.5,
    width: 16.1945,
    height: 16.2778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2098_16259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2098_16259",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.152941 0 0 0 0 0.803922 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_2098_16259",
    x: 32.625,
    y: 19.5,
    width: 16.1945,
    height: 16.2778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2098_16259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2098_16259",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.152941 0 0 0 0 0.803922 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_di_2098_16259",
    x: 87.3057,
    y: 44.4546,
    width: 16.1946,
    height: 16.2778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2098_16259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2098_16259",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.152941 0 0 0 0 0.803922 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_di_2098_16259",
    x: 51,
    y: 29.125,
    width: 16.1946,
    height: 16.2778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2098_16259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2098_16259",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.152941 0 0 0 0 0.803922 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_di_2098_16259",
    x: 51,
    y: 87.75,
    width: 16.1946,
    height: 16.2778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2098_16259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2098_16259",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.152941 0 0 0 0 0.803922 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2098_16259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2098_16259",
    x1: 57.9998,
    y1: 0.249791,
    x2: 57.9998,
    y2: 115.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.026547,
    stopColor: "#D3C5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363501,
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365013,
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492584,
    stopColor: "#D3C5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755656,
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7750E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2098_16259",
    x1: 58.0002,
    y1: 3.75006,
    x2: 58.0002,
    y2: 112.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244344,
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507416,
    stopColor: "#B098F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634987,
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636499,
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973453,
    stopColor: "#B098F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2098_16259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58 58) scale(63.7825 56.3357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.626538,
    stopColor: "#24222A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18171C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2098_16259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58 58) scale(63.7825 56.3357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.626538,
    stopColor: "#24222A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18171C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2098_16259",
    x1: 34.375,
    y1: 66.75,
    x2: 53.625,
    y2: 66.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6238DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2098_16259",
    x1: 62.375,
    y1: 66.75,
    x2: 81.625,
    y2: 66.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6238DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2098_16259",
    x1: 24.75,
    y1: 86,
    x2: 63.25,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6238DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2098_16259",
    x1: 52.75,
    y1: 86,
    x2: 91.25,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6238DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2098_16259",
    x1: 16.875,
    y1: 60.4426,
    x2: 22.125,
    y2: 65.2551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2098_16259",
    x1: 72,
    y1: 25.6252,
    x2: 77.25,
    y2: 30.4377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2098_16259",
    x1: 37,
    y1: 25.6252,
    x2: 42.25,
    y2: 30.4377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2098_16259",
    x1: 91.6807,
    y1: 50.5798,
    x2: 96.9307,
    y2: 55.3923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2098_16259",
    x1: 55.375,
    y1: 35.2502,
    x2: 60.625,
    y2: 40.0627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2098_16259",
    x1: 55.375,
    y1: 93.8752,
    x2: 60.625,
    y2: 98.6877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2098_16259",
    x1: -1.5,
    y1: 86,
    x2: 103.5,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6238DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B098F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertBadgeIcon);
export default __webpack_public_path__ + "static/media/ExpertBadgeIcon.19e2d1cccc2297b6021620e3c3124080.svg";
export { ForwardRef as ReactComponent };